import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { CASHBACK_VALUE } from 'shared/constants'
import MBonusImage from 'shared/images/mbonus-popup.png'
import { Button } from 'shared/ui/button'
import { useDialogBottomSheet } from 'shared/ui/dialog-bottom-sheet/lib'

import s from './styles.module.scss'

export const MbonusPopup = () => {
  const { t } = useTranslation()

  const { closeDialog } = useDialogBottomSheet()

  const onClose = () => {
    closeDialog()
  }
  return (
    <div className={s.mbonusPopup}>
      <div className={s.wrapper}>
        <img
          src={MBonusImage}
          alt=""
          className={s.image}
        />

        <div className={s.text}>
          <h3 className={clsx(s.title, 'bold-20')}>
            {t('mbonus_popup.title', { amount: CASHBACK_VALUE })}
          </h3>

          <p className={clsx(s.description, 'regular-14')}>
            {' '}
            {t('mbonus_popup.description', { amount: CASHBACK_VALUE })}
          </p>
          <br />
          <p className={clsx(s.description, 'regular-14')}>
            {t('mbonus_popup.bonus_to_som')}
          </p>
        </div>

        <Button onClick={onClose}>
          <span className="bold-17">{t('continue')}</span>
        </Button>
      </div>
    </div>
  )
}
